import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Switch,
  Button,
  SelectChangeEvent,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { isValidInput } from "../../utils/validations";
import {
  useLazyGetPropertiesQuery,
  useDeletePropertyMutation,
  useLazyGetAreaQuery,
  useLazyGetPropertiesCsvQuery,
} from "../../services/property";
import { useLazyGetCategoriesQuery } from "../../services/main";
import { Loader, showError, showToast } from "../../constants";
import { Property } from "../../types/General";
import WarnModal from "../../components/WarnModal";
import Pagination from "../../components/Pagination";
import useAuth from "../../hooks/useAuth";
import useTranslation from "../../hooks/Translation";
import { useLanguageContext } from "../../context/Language";
import NoDataFound from "../../components/NoDataFound";
import { downloadCsv } from "../../utils/exportCsv";
import SkeletonTable from "../../components/SkeletonTable";
import { formatPhoneLtr } from "../../utils/phoneDisplay";

const ManageProperties = () => {
  const navigate = useNavigate();
  const userData = useAuth();
  const { language } = useLanguageContext() as any;
  const [getPropertiesQuery, { isLoading, isFetching, isSuccess }] = useLazyGetPropertiesQuery();
  const [propertyCsv] = useLazyGetPropertiesCsvQuery();
  const [getAreaQuery] = useLazyGetAreaQuery();
  const [getCategories] = useLazyGetCategoriesQuery();
  const [deleteProperty] = useDeletePropertyMutation();
  const translate = useTranslation();
  const [receiver, setReceiver] = useState<string>("");
  const [receiver1, setReceiver1] = useState<string>("");
  const [listingType, setListingType] = useState<string>("");
  const [listingStatus, setListingStatus] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [allProperty, setAllProperty] = useState<Property[]>([]);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [page, setPage] = useState(1);
  const [allArea, setAllArea] = useState<any>([]);
  const [allCategories, setAllCategories] = useState<any[]>([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [hidePermission, setHidePermission] = useState<any>({
    isAdd: true,
    isDelete: true,
  });

  const handleReceiverChange = (event: SelectChangeEvent) => {
    setReceiver(event.target.value as string);
    setPage(1);
  };

  const handleReceiverChange1 = (event: SelectChangeEvent) => {
    setReceiver1(event.target.value as string);
    setPage(1);
  };

  const handleListingTypeChange = (event: SelectChangeEvent) => {
    setListingType(event.target.value as string);
    setPage(1);
  };

  const handleListingStatusChange = (event: SelectChangeEvent) => {
    setListingStatus(event.target.value as string);
    setPage(1);
  };

  const handleCategoryChange = (event: SelectChangeEvent) => {
    setSelectedArea(event.target.value as string);
    setPage(1);
  };

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };
  let totalPages = Math.ceil(totalCount / 10);

  const getProperties = async () => {
    setLoading(true);
    try {
      const response = await getPropertiesQuery({
        query: debouncedSearchTerm.trim(),
        page: page,
        type: 0,
        preference: Number(receiver1),
        areaId: selectedArea,
        categoryId: receiver,
        listingType: listingType,
        listingStatus: listingStatus,
      }).unwrap();
      if (response?.statusCode === 200) {
        setAllProperty(response?.data?.property || []);
        setTotalCount(response?.data?.count);
      } else {
        setAllProperty([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    } finally {
      setLoading(false);
    }
  };

  const getArea = async () => {
    try {
      const response = await getAreaQuery({
        page: 1,
      }).unwrap();
      if (response?.statusCode === 200) {
        setAllArea(response?.data || []);
      } else {
        setAllArea([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const getCategoryList = async () => {
    try {
      const response = await getCategories({
        query: "",
        page: 1,
        size: 50,
        type: 1,
        categoryId: "",
      }).unwrap();
      if (response?.statusCode === 200) {
        setAllCategories(response?.data?.category || []);
      } else {
        setAllCategories([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const handleClearFilters = () => {
    setReceiver("");
    setReceiver1("");
    setSelectedArea("");
    setListingType("");
    setListingStatus("");
    setPage(1);
  };

  const handleDelete = async (id: string) => {
    try {
      const response = await deleteProperty({ propertyId: id }).unwrap();
      if (response?.statusCode === 200) {
        showToast(translate?.error?.propertyDel || "");
        getProperties();
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const getPropertyCsv = async () => {
    try {
      const response = await propertyCsv({
        query: debouncedSearchTerm.trim(),
        type: 0,
        preference: Number(receiver1),
        areaId: selectedArea,
        categoryId: receiver,
        listingType: listingType,
        listingStatus: listingStatus,
      }).unwrap();
      if (response?.statusCode === 200) {
        await downloadCsv(response?.data, "properties.csv");
      } else {
        showError(translate?.error?.exportFailed || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || translate?.error?.exportFailed || "");
    }
  };

  const getListingStatusLabel = (row: Property) => {
    if (row?.isRefundRequested) {
      return translate?.properties?.refundInProgress || "Refund in progress";
    }
    if (row?.status === 0) {
      return translate?.properties?.pending || "Pending";
    }
    if (row?.status === 1) {
      return translate?.properties?.published || "Published";
    }
    if (row?.status === 2) {
      return translate?.properties?.expired || "Expired";
    }
    if (row?.status === 3) {
      return translate?.properties?.saveForLater || "Save for later";
    }
    if (row?.status === 4) {
      return (
        translate?.properties?.rtaTimeout ||
        translate?.properties?.rejected ||
        "RTA timeout"
      );
    }
    return "-";
  };

  const checkPermission = () => {
    const permissions = userData?.permission;
    if (permissions?.length) {
      let idx = -1;
      idx = permissions?.findIndex(
        (ele: any) => ele?.name === "Manage Properties"
      );

      if (idx != -1) {
        let data = {
          isAdd: permissions[idx]?.isAdd,
          isDelete: permissions[idx]?.isDelete,
        };
        setHidePermission(data);
      } else {
        setHidePermission({ isAdd: false, isDelete: false });
      }
    }
  };

  useEffect(() => {
    getProperties();
  }, [
    receiver,
    receiver1,
    listingType,
    listingStatus,
    debouncedSearchTerm,
    selectedArea,
    page,
  ]);

  useEffect(() => {
    getArea();
    getCategoryList();
  }, []);

  useEffect(() => {
    if (userData && userData?.permission?.length) {
      checkPermission();
    }
  }, [userData]);

  return (
    <MainContainer>
      <Loader isLoad={loading} isLinear />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{translate?.main?.ManageProperties}</h1>
        </div>
        <Card className="cards">
          <div className="cards_header">
            <SearchBar
              value={searchTerm}
              searchTerm={searchTerm}
              onCross={() => setSearchTerm("")}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
            <Box className="cards_header_right">
              <Button className="btn btn_primary" onClick={getPropertyCsv}>
                <FileDownloadIcon /> {translate?.dashboard?.ExportCsv}
              </Button>
              {hidePermission?.isAdd ? (
                <Button
                  className="btn btn_primary"
                  onClick={() => navigate("/manage-properties/add")}
                >
                  {translate?.main?.Add}
                </Button>
              ) : null}
            </Box>
          </div>

          <Box className="property_filters_row">
            <Box className="property_filters_selects">
              <FormControl sx={{ width: "100%" }}>
                <Select
                  fullWidth
                  className="select_div"
                  value={listingStatus}
                  inputProps={{
                    "aria-label": "Listing status",
                  }}
                  displayEmpty
                  onChange={handleListingStatusChange}
                >
                  <MenuItem value="">
                    {translate?.properties?.listingStatus || "Status"} —{" "}
                    {translate?.main?.All || "All"}
                  </MenuItem>
                  <MenuItem value="published">
                    {translate?.properties?.published || "Published"}
                  </MenuItem>
                  <MenuItem value="saveForLater">
                    {translate?.properties?.saveForLater || "Save for later"}
                  </MenuItem>
                  <MenuItem value="expired">
                    {translate?.properties?.expired || "Expired"}
                  </MenuItem>
                </Select>
              </FormControl>
              <FormControl sx={{ width: "100%" }}>
                <Select
                  fullWidth
                  className="select_div"
                  value={listingType}
                  inputProps={{
                    "aria-label": "Listing type",
                  }}
                  displayEmpty
                  onChange={handleListingTypeChange}
                >
                  <MenuItem value="">
                    {translate?.properties?.listingType || "Listing Type"} —{" "}
                    {translate?.main?.All || "All"}
                  </MenuItem>
                  <MenuItem value="1">
                    {translate?.properties?.listingNormal || "Normal"}
                  </MenuItem>
                  <MenuItem value="2">
                    {translate?.properties?.listingHighlighted || "Highlighted"}
                  </MenuItem>
                  <MenuItem value="3">
                    {translate?.properties?.requestToAgent ||
                      "Request to Agent"}
                  </MenuItem>
                </Select>
              </FormControl>
              <FormControl sx={{ width: "100%" }}>
                <Select
                  fullWidth
                  className="select_div"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={receiver}
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  onChange={handleReceiverChange}
                >
                  <MenuItem value="" disabled>
                    {translate?.main?.All}
                  </MenuItem>
                  {allCategories?.map((item: any) => (
                    <MenuItem key={item?._id} value={item?._id}>
                      {(language === "ar"
                        ? item?.name_ar || item?.name
                        : item?.name) || ""}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ width: "100%" }}>
                <Select
                  fullWidth
                  className="select_div"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={receiver1}
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  onChange={handleReceiverChange1}
                >
                  <MenuItem value="" disabled>
                    {translate?.main?.UserPreferences}
                  </MenuItem>
                  <MenuItem value="1">
                    {" "}
                    {translate?.main?.MostViewedProperties}
                  </MenuItem>
                  <MenuItem value="2">
                    {" "}
                    {translate?.main?.MostSearchedProperties}
                  </MenuItem>
                </Select>
              </FormControl>
              <FormControl sx={{ width: "100%" }}>
                <Select
                  className="select_div"
                  fullWidth
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedArea}
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  onChange={handleCategoryChange}
                >
                  <MenuItem value="" disabled>
                    {translate?.main?.Mostsearchedbyarea}
                  </MenuItem>
                  {allArea?.area?.length
                    ? allArea?.area?.map((item: any) => (
                      <MenuItem key={item?._id} value={item?._id}>
                        {(language === 'ar' ? item?.name_ar || item?.name : item?.name) || ""}
                      </MenuItem>
                    ))
                    : null}
                </Select>
                {!allArea?._id && !allArea ? (
                  <h6 className="err_msg">
                    {translate?.main?.Pleaseselectcategory}
                  </h6>
                ) : (
                  ""
                )}
              </FormControl>
            </Box>
            <Box className="property_filters_actions">
              {receiver !== "" ||
              receiver1 !== "" ||
              selectedArea !== "" ||
              listingType !== "" ||
              listingStatus !== "" ? (
                <Button className="btn" onClick={() => handleClearFilters()}>
                  {translate?.properties?.clearFilters}
                </Button>
              ) : null}
            </Box>
          </Box>
          <TableContainer className="table_container">
            <Box className="heading"></Box>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">{translate?.main?.SNo}</TableCell>
                  <TableCell>{translate?.main?.propertyName}</TableCell>
                  <TableCell>{translate?.main?.PropertyCategory}</TableCell>
                  {/* <TableCell>{translate?.main?.AgentName}</TableCell> */}
                  <TableCell>{translate?.main?.AgentCustomerName}</TableCell>
                  <TableCell>{translate?.main?.Email}</TableCell>
                  <TableCell>{translate?.main?.PhoneNo}</TableCell>
                  <TableCell>{translate?.main?.Location}</TableCell>
                  <TableCell>{translate?.main?.Type}</TableCell>
                  <TableCell>
                    {translate?.properties?.listingStatus || "Status"}
                  </TableCell>
                  {(hidePermission?.isAdd || hidePermission?.isDelete) ? (
                    <TableCell className="table-action-cell">{translate?.main?.Action}</TableCell>
                  ) : null}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <SkeletonTable columns={10} rows={10} />
                ) : allProperty?.length > 0 ? (
                  allProperty?.map((row, i) => (
                    <TableRow key={row?._id}>
                      <TableCell align="center">
                        {(page - 1) * 10 + i + 1}
                      </TableCell>
                      <TableCell>{language === 'ar' ? `${row?.subCategoryId?.name_ar || row?.subCategoryId?.name} ${row?.categoryId?.name_ar || row?.categoryId?.name} ${row?.subAreaId?.name_ar || row?.subAreaId?.name}` : `${row?.subCategoryId?.name} for ${row?.categoryId?.name} in ${row?.subAreaId?.name}`}</TableCell>
                      <TableCell>{(language === 'ar' ? row?.categoryId?.name_ar || row?.categoryId?.name : row?.categoryId?.name) || ""}</TableCell>
                      {/* <TableCell>{row?.agentName || "-"}</TableCell> */}
                      <TableCell>
                        {row?.userId?.fullName || translate?.properties?.byAdmin}
                      </TableCell>
                      <TableCell>{row?.userId?.email || "-"}</TableCell>
                      <TableCell>
                        {formatPhoneLtr(
                          row?.userId?.countryCode,
                          row?.userId?.phone
                        )}
                      </TableCell>
                      <TableCell>{(language === 'ar' ? row?.subAreaId?.name_ar || row?.subAreaId?.name : row?.subAreaId?.name) || "-"}</TableCell>
                      <TableCell>
                        {row?.listingType == 1
                          ? translate?.properties?.listingNormal
                          : row?.listingType == 2
                            ? translate?.properties?.listingHighlighted
                            : translate?.properties?.requestToAgent ||
                              translate?.properties?.listingAgent}
                      </TableCell>
                      <TableCell>{getListingStatusLabel(row)}</TableCell>
                      {(hidePermission?.isAdd || hidePermission?.isDelete) ? (
                        <TableCell className="table-action-cell">
                          <Box className="table_actions">
                            <IconButton
                              onClick={() =>
                                navigate(`/manage-properties/details/${row?._id}`)
                              }
                            >
                              <VisibilityIcon />
                            </IconButton>
                            {hidePermission?.isAdd ? (
                              <IconButton
                                onClick={() =>
                                  navigate(`/manage-properties/edit/${row?._id}`)
                                }
                              >
                                <ModeEditIcon />
                              </IconButton>
                            ) : null}
                            {hidePermission?.isDelete ? (
                              <IconButton
                                onClick={() => {
                                  setOpen(true);
                                  setSelectedId(row?._id);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            ) : null}
                          </Box>
                        </TableCell>
                      ) : null}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={10}>
                      <NoDataFound message={translate?.main?.NoPropertiesFound} />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>

        {allProperty?.length > 0 ? (
          <Pagination
            setPage={setPage}
            module={allProperty}
            page={page}
            onPageChange={onPageChange}
            totalPages={totalPages}
          />
        ) : (
          ""
        )}
      </div>
      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => handleDelete(selectedId)}
        name="Property"
      />
    </MainContainer>
  );
};

export default ManageProperties;
